<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t("hotpicks") }}
    </h1>
    <!-- <select name="" id="" @change="fetchHotPicksGame([$route.query.q, $event])">
      <option value="">--Select View--</option>
      <option value="200">200</option>
      <option value="100">100</option>
      <option value="50">50</option>
      <option value="20">20</option>
      <option value="10">10</option>
      <option value="5">5</option>
    </select> -->
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__header">
          <h2 class="mobiTitle md">
            <img class="mobiIcon" :src="IconHotPick_f2w" alt=""/>
            <span class="text_color">{{ $t("all") }} {{ $t("hotpicks") }} {{ getSubCategory($route.query.q, lang_f2w) }}</span>
          </h2>
        </div>
        <div v-if="isLoad === false">
          <svg class="spinner" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>
        <div v-if="isLoad === true">
          <div class="mobiSection__content">
            <div class="row">
              <div  v-for="hot in getHotPicks()" :key="hot.key" :class="hot.class">
                <div>
                    <router-link class="browse_link mobiApp" :to="{ name: 'DetailPage', params: { id: hot.content_id } }">
                    <div v-if="hot.content_type === 'application/x-zip-compressed' && hot.category === 'Game'" class="mobibadge badge--html5">
                      <img src="../../assets/mobizone/imgs/html5-badge.png"/>
                    </div>
                    <div class="mobiApp__thumb">
                      <img class="img_wrp" :src="hot.thumbnail_url" alt="" />
                    </div>
                    <div class="mobiApp__info">
                      <!-- <h3 class="mobiTitle sm text_color">{{hot.content_name}}</h3> -->
                      <span v-if="lang_f2w !== 'english'">
                          <h3 class="mobiTitle sm text_color" v-if="hot[`cont_name_${lang_f2w}`] !== ''">{{ hot[`cont_name_${lang_f2w}`] }}</h3>
                          <h3 class="mobiTitle sm text_color" v-else>{{ hot[`cont_name_english`] }}</h3>
                        </span>
                        <span v-else>
                          <h3 class="mobiTitle sm text_color">{{ hot[`cont_name_english`] }}</h3>
                        </span>
                      <!-- <p>{{ hot.total_download }} {{$t("downloads")}}</p> -->
                      <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01"  active-color="#21d0e3" :show-rating="false" :border-width="3" border-color="#21d0e3" :rounded-corners="false" inactive-color="#151515" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :rating="Number(hot.rating)"></star-rating>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import StarRating from 'vue-star-rating'
// Vue.component("star-rating", VueStarRating.default);
export default {
  data() {
    return {
      query: "",
      isLoad: false
    };
  },
  components:{
    StarRating
  },
  props: ["browse"],
  computed: mapGetters(["HotPicksPage_f2w", "IconHotPick_f2w", "lang_f2w"]),
  created() {
    this.isLoad = false
    this.fetchHotPicks_f2w([this.$route.query.q]);
    this.getHotPicks();
  },
  updated() {
    if(this.$route.query.q != this.query){
      this.isLoad = false
      this.fetchHotPicks_f2w([this.$route.query.q]);
      this.getHotPicks()
      this.query = this.$route.query.q;
    }
  },
  methods: {
    ...mapActions(["fetchHotPicks_f2w"]),
    getHotPicks() {
      let hotpick = [...this.HotPicksPage_f2w];
      let hot = [];
      hotpick.map(item => {
        item["class"] = "col-6 col-md-3 col-lg-2 col-sm-4 mobiColItem";
        hot.push(item);
      });
      setTimeout(() => {
        this.isLoad = true
      }, 2500);
      return hot;
    },
    getSubCategory(subcategory, lang) {
      let cat_translate = [];
      let hotpick = this.$props.browse.category;

      hotpick.map(item => {
        if (item.title_english == subcategory) {
          if (lang != null) {
            cat_translate.push(item[`title_${lang}`]);
          } else {
            cat_translate.push(item[`title_english`]);
          }
        }
      });

      return cat_translate[0];
    }
  }
};
</script>

<style scoped>
.main_title {
  color: black;
}
.main_part div {
  display: inline-block;
  padding: 0 3px;
  color: black;
}
.browse_link {
  color: black;
}

.icon {
  height: 32px;
  width: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/fun2win/HotPicks.vue